import script from "./pingJia.vue?vue&type=script&setup=true&lang=js"
export * from "./pingJia.vue?vue&type=script&setup=true&lang=js"

import "./pingJia.vue?vue&type=style&index=0&id=2ad07b4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad07b4c"]])

export default __exports__